import {
	configurationCSV,
	iMappingField,
	importConfiguration
} from "@/models/importModels";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import baseContextComponent from "../baseContextComponent";

enum sortFields {
	alfabetico = "alfabetico",
	file = "file"
}

@Component({})
export default class importConfigCSV extends baseContextComponent {
	sortType: string = "alfabetico";
	@Prop({ default: false })
	hasMappingsChanged: boolean;
	@Prop({ default: false })
	realTime: boolean;
	get isRealTime(): boolean {
		return this.realTime;
	}
	set isRealTime(v: boolean) {
		this.$emit("realTimeChange", v);
	}
	onRealTimeChange(v: boolean) {
		this.isRealTime = v;
		//this.$emit("realTimeChange", v);
	}
	search: string = null;
	file: File = null;
	showModal: boolean = false;
	@Watch("showModal")
	onShowModalChange(showModalNew: boolean, showModalOld: boolean) {
		var self = this;
		self.search = null;
	}
	selectdField: iMappingField = null;
	get modalTitle(): string {
		var self = this;
		return `${self.selectdField == null ? "" : self.selectdField.columnName
			}`;
	}
	@Prop({ default: () => null })
	mappingFileFields: string[];
	get mappingFileFieldsList(): string[] {
		var self = this;
		// (self.mappingFileFields || []).splice(0);
		var list = [...(self.mappingFileFields || [])];
		if (self.search != null && self.search.trim() != "")
			list = (list || []).filter(
				x =>
					x != null &&
					x.toLowerCase().search(self.search.toLowerCase()) !== -1
			);

		if (self.sortType == "file") return list;

		return list.sort();
	}
	@Prop({ default: () => new importConfiguration<configurationCSV>() })
	value: importConfiguration<configurationCSV>;
	get item(): importConfiguration<configurationCSV> {
		return this.value;
	}
	set item(value: importConfiguration<configurationCSV>) {
		this.$emit("input", value);
	}
	get hasFile(): boolean {
		var self = this;
		return (
			self.mappingFileFields != null && self.mappingFileFields.length > 0
		);
	}
	get fileInputPlaceholder(): string {
		var self = this;
		if (self.hasFile) {
			return "caricare un altro file";
		} else {
			return "carica un file";
		}
	}
	onConfigField(m: iMappingField) {
		var self = this;
		self.selectdField = m;
		if (self.hasFile) {
			self.showModal = true;
		} else {
			self.$bvToast.toast("Caricare prima un file per il mapping", {
				variant: "warning",
				title: "Nessun file salvato",
				solid: true
			});
		}
	}
	@Watch("file")
	onFileSlected(fNew: File, fOld: File) {
		var self = this;
		self.$emit("selectedFile", fNew);
	}
	onSelectMappingField(m: string) {
		var self = this;
		self.selectdField.sourceCode = m;
		self.showModal = false;
	}
	listaAssociati(m: string): string {
		var self = this;
		var ass = (self.value.columnsMapping || []).filter(
			x => x.sourceCode == m
		);
		if (ass == null || ass.length == 0) return null;
		return ass.map(x => x.columnName).join(", ");
	}
	associata(m: string): boolean {
		var self = this;
		if (self.selectdField == null) return false;
		var ass = (self.value.columnsMapping || []).filter(
			x =>
				x.sourceCode == m &&
				x.columnName == self.selectdField.columnName
		);
		return ass != null && ass.length > 0;
	}
}
